import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaBook } from 'react-icons/fa';

function Publications() {
  const publications = [
    'Platinum Edition Using Windows NT Server 4',
    'Beginning ASP.NET Databases using C#',
    'PC Print',
    'The Site Server Story',
    'Beginning Dynamic Websites: with ASP.NET Web Matrix',
  ];

  return (
    <section id="publications" className="publications-section section-padding">
      <Container>
        <div className="section-divider"></div>
        <h2 className="section-title">Publications</h2>
        <p className="section-subtitle">Technical books and articles sharing knowledge with the developer community</p>

        <Row className="g-4">
          {publications.map((pub, index) => (
            <Col md={6} key={index}>
              <div className="pub-card">
                <div className="pub-icon">
                  <FaBook />
                </div>
                <div>
                  <h6>{pub}</h6>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Publications;
